import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function SubmitQuery() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    country: '',
    specialty: 'cardiology',
    medicalHistory: '',
    visaRequired: 'no'
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Lead Captured:', formData);
    setSubmitted(true);
  };

  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      {/* MOBILE BREAKPOINT STYLES OVERRIDE */}
      <style>{`
        @media (max-width: 550px) {
          .submit-footer-btn { width: 100% !important; text-align: center; box-sizing: border-box; }
        }
      `}</style>

      {/* HEADER HERO SECTION */}
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Submit Medical Travel Query: Premium Private Hospital Care Information Desk
        </h1>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '24px' }}>
          Planning specialized healthcare treatments overseas—such as complex coronary angioplasty, high-flex robotic joint reconstructions, or targeted oncology protocols—requires thorough pre-travel evaluation. By aggregating public care data on independent research indices like <strong>Medical Trip World</strong>, cross-border patients can streamline their data compilation protocols safely.
        </p>
        <p style={{ color: '#444', lineHeight: '1.8', fontSize: 'clamp(0.95rem, 3.5vw, 1.1rem)', marginBottom: '25px' }}>
          Use the secure administrative entry form below to compile your historical diagnostics, indicate timeline requirements, and access structural cost comparison matrices across elite private corporate hospital networks in New Delhi, Gurgaon, and Noida.
        </p>
      </header>

      <hr style={{ border: 'none', borderTop: '1px solid #eee', margin: '30px 0' }} />

      {/* TWO-COLUMN CONVERSION LAYOUT */}
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px' }}>
        
        {/* LEFT COLUMN: HIGH-CONVERSION SECURE FORM */}
        <div style={{ flex: '1 1 500px', background: '#f4f8fb', padding: 'clamp(15px, 4vw, 30px)', borderRadius: '6px', border: '1px solid #e0e6ed', boxSizing: 'border-box' }}>
          <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '20px', fontSize: '1.35rem', borderBottom: '2px solid #ff9f1c', paddingBottom: '8px' }}>
            Secure Medical Information Request Form
          </h3>

          {submitted ? (
            <div style={{ background: '#d4edda', color: '#155724', padding: '20px', borderRadius: '4px', border: '1px solid #c3e6cb' }}>
              <h4 style={{ margin: '0 0 10px 0' }}>✓ Information Compilation Initiated</h4>
              <p style={{ margin: '0', fontSize: '0.95rem', lineHeight: '1.6' }}>
                Your diagnostic parameters and timeline requests have been organized within our independent system index. Please check your secure email portal for standard pre-travel data toolkits.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
              
              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333', fontSize: '0.9rem' }}>Full Name:</label>
                <input type="text" name="fullName" required value={formData.fullName} onChange={handleChange} style={{ width: '100%', padding: '12px', borderRadius: '4px', border: '1px solid #ccc', outline: 'none', boxSizing: 'border-box', minHeight: '44px' }} placeholder="John Doe" />
              </div>

              <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                <div style={{ flex: '1 1 200px' }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333', fontSize: '0.9rem' }}>Email Address:</label>
                  <input type="email" name="email" required value={formData.email} onChange={handleChange} style={{ width: '100%', padding: '12px', borderRadius: '4px', border: '1px solid #ccc', outline: 'none', boxSizing: 'border-box', minHeight: '44px' }} placeholder="john@example.com" />
                </div>
                <div style={{ flex: '1 1 200px' }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333', fontSize: '0.9rem' }}>Contact Number (With Country Code):</label>
                  <input type="tel" name="phone" required value={formData.phone} onChange={handleChange} style={{ width: '100%', padding: '12px', borderRadius: '4px', border: '1px solid #ccc', outline: 'none', boxSizing: 'border-box', minHeight: '44px' }} placeholder="+1 555 0199" />
                </div>
              </div>

              <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap' }}>
                <div style={{ flex: '1 1 200px' }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333', fontSize: '0.9rem' }}>Country:</label>
                  <input type="text" name="country" required value={formData.country} onChange={handleChange} style={{ width: '100%', padding: '12px', borderRadius: '4px', border: '1px solid #ccc', outline: 'none', boxSizing: 'border-box', minHeight: '44px' }} placeholder="United States" />
                </div>
                <div style={{ flex: '1 1 200px' }}>
                  <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333', fontSize: '0.9rem' }}>Target Specialty Area:</label>
                  <select name="specialty" value={formData.specialty} onChange={handleChange} style={{ width: '100%', padding: '12px', borderRadius: '4px', border: '1px solid #ccc', outline: 'none', background: '#fff', boxSizing: 'border-box', minHeight: '44px' }}>
                    <option value="cardiology">Cardiology (Angioplasty/Bypass)</option>
                    <option value="orthopedics">Orthopedics (Knee/Hip Joints)</option>
                    <option value="oncology">Oncology (Cancer Care)</option>
                    <option value="dental">Dental Tourism Packages</option>
                    <option value="other">Other Specialized Interventions</option>
                  </select>
                </div>
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333', fontSize: '0.9rem' }}>Brief Summary of Clinical Condition:</label>
                <textarea name="medicalHistory" required value={formData.medicalHistory} onChange={handleChange} rows="4" style={{ width: '100%', padding: '12px', borderRadius: '4px', border: '1px solid #ccc', outline: 'none', resize: 'vertical', boxSizing: 'border-box' }} placeholder="Please specify diagnosed blocks, joint degradation status, or recent MRI/CT scan dates..."></textarea>
              </div>

              <div>
                <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold', color: '#333', fontSize: '0.9rem' }}>Do you require electronic Medical Visa Invitation Letter (VIL) guides?</label>
                <div style={{ display: 'flex', gap: '20px', marginTop: '5px', flexWrap: 'wrap' }}>
                  <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', minHeight: '35px' }}><input type="radio" name="visaRequired" value="yes" checked={formData.visaRequired === 'yes'} onChange={handleChange} /> Yes, request immigration path maps</label>
                  <label style={{ display: 'inline-flex', alignItems: 'center', gap: '6px', minHeight: '35px' }}><input type="radio" name="visaRequired" value="no" checked={formData.visaRequired === 'no'} onChange={handleChange} /> No, I hold active travel clearance</label>
                </div>
              </div>

              <button type="submit" style={{ background: '#28a745', color: '#fff', padding: '14px 28px', border: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '1.05rem', cursor: 'pointer', boxShadow: '0 2px 4px rgba(40,167,69,0.2)', marginTop: '10px', width: '100%', minHeight: '44px' }}>
                Submit Information Request Securely →
              </button>
            </form>
          )}
        </div>

        {/* RIGHT COLUMN: LEAD TRUST TRUST BUILDERS */}
        <div style={{ flex: '1 1 300px', display: 'flex', flexDirection: 'column', gap: '20px', boxSizing: 'border-box' }}>
          
          <div style={{ padding: '20px', border: '1px solid #eee', borderRadius: '6px', background: '#fafafa', boxSizing: 'border-box', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem' }}>🔒 Data Privacy Protocols</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.6' }}>
              All submitted data, chronological records, and diagnostic inputs are mapped through encrypted portal pipelines in full compliance with international patient data confidentiality regulations.
            </p>
          </div>

          <div style={{ padding: '20px', border: '1px solid #eee', borderRadius: '6px', background: '#fafafa', boxSizing: 'border-box', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem' }}>📋 Document Preparation Tip</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.6' }}>
              To ensure processing efficiency, gather high-resolution duplicates of universal DICOM radiology discs, laboratory blood panels, and active daily medication scripts translated fully into English.
            </p>
          </div>

          <div style={{ padding: '20px', border: '1px solid #eee', borderRadius: '6px', background: '#fafafa', boxSizing: 'border-box', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
            <h4 style={{ margin: '0 0 10px 0', color: '#0b3c5d', fontSize: '1.05rem' }}>⏱ Expected Response Windows</h4>
            <p style={{ margin: '0', fontSize: '0.9rem', color: '#666', lineHeight: '1.6' }}>
              Once your medical parameters are correctly compiled into our index layout, standard reference tracking toolkits are typically delivered to your provided email location within 24 to 48 business hours.
            </p>
          </div>

        </div>
      </div>

      {/* SECTION 3: IMMIGRATION & COMPLIANCE REGULATORY DISCLAIMER */}
      <section style={{ marginTop: '40px', background: '#fff', border: '1px solid #e0e0e0', padding: '25px', borderRadius: '6px', boxSizing: 'border-box', boxShadow: '0 1px 3px rgba(0,0,0,0.02)' }}>
        <h3 style={{ color: '#0b3c5d', marginTop: '0', marginBottom: '15px', fontSize: '1.25rem', fontWeight: '700' }}>
          Regulatory Directory Framework Acknowledgments
        </h3>
        <p style={{ color: '#555', fontSize: '0.9rem', lineHeight: '1.6', margin: '0' }}>
          <strong>Medical Trip World</strong> operates exclusively as an open, independent informational manual and directory search reference tool. We do not provide clinical interventions, employ consulting surgeons, operate hospital triage helpdesks, or function as a licensed medical provider. Submitting a query via this portal serves as an informational database request to track comparative benchmarks. 
          All definitive diagnostic evaluations, absolute pricing contracts, legal Medical Visa invitation packages, and therapeutic care obligations are negotiated directly, explicitly, and solely between the traveler and their independently self-selected private corporate healthcare professional.
        </p>
      </section>

      {/* RE-ENGAGEMENT FOOTER */}
      <footer style={{ borderTop: '1px solid #eee', paddingTop: '20px', textAlign: 'center', marginTop: '40px' }}>
        <div style={{ display: 'flex', gap: '12px', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center' }}>
          <Link to="/compare-costs" className="submit-footer-btn" style={{ background: '#0b3c5d', color: '#fff', padding: '12px 25px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            View Estimated Cost Charts
          </Link>
          <Link to="/visa-guides" className="submit-footer-btn" style={{ background: '#fff', color: '#0b3c5d', border: '2px solid #0b3c5d', padding: '10px 23px', textDecoration: 'none', borderRadius: '4px', fontWeight: 'bold', fontSize: '0.9rem', display: 'inline-block' }}>
            Review Visa Guidelines
          </Link>
        </div>
      </footer>

    </article>
  );
}

export default SubmitQuery;